import { MessagingSystem } from "../messages/messaging.system";
import { Injectable } from "@angular/core";
import { AbacusNd1Map } from "../map/maps/abacus.nd.1.map";
import { AbacusNd2Map } from "../map/maps/abacus.nd.2.map";
import { AbacusNd05Map } from "../map/maps/abacus.nd.0.5.map";
import { AbacusNd3Map } from "../map/maps/abacus.nd.3.map";
import { AbacusNd4Map } from "../map/maps/abacus.nd.4.map";

@Injectable({
    providedIn: 'root'
})
export class Settings {
    public readonly DEFAULT_ALGORITHM = MessagingSystem.SprayAndWait;

    public readonly MAX_MESSAGE_SIZE = 1000;
  
    public readonly MIN_NUMBER_OF_NODES = 2;
    public readonly MAX_NUMBER_OF_NODES = 100;
    public readonly DEFAULT_NUMBER_OF_NODES = 60;

    public readonly MIN_MESSAGE_COPIES = 1;
    public readonly MAX_MESSAGE_COPIES = 100;
    public readonly DEFAULT_MESSAGE_COPIES = 5;
  
    public readonly MIN_SIMULATION_SPEED = 0.1;
    public readonly MAX_SIMULATION_SPEED = 10;
    public readonly DEFAULT_SIMULATION_SPEED = 5;

    public readonly MIN_SIMULATION_TIME = 1;
    public readonly MAX_SIMULATION_TIME = 10000;
    public readonly DEFAULT_SIMULATION_TIME = 1000;

    public readonly MIN_NODE_RADIUS = 5;
    public readonly MAX_NODE_RADIUS = 150;
    public readonly DEFAULT_NODE_RADIUS = 50;

    public readonly MIN_MESSAGE_FREQUENCY = 1;
    public readonly MAX_MESSAGE_FREQUENCY = 10;
    public readonly DEFAULT_MESSAGE_FREQUENCY = 5;

    // Abacus settings
    public readonly TRAIN_MESSAGES_PER_ABACI = 15;
    public readonly ABACI_TO_CREATE = {
        numCopies: [2, 5, 10, 15, 20],
        avgNodeDegree: [1, 2, 3, 4]
    };
    public readonly DESIRED_AVG_DELAY = 9000;

    public readonly NODE_DEGREE_TO_MAP: any = {
        0.5: AbacusNd05Map,
        1: AbacusNd1Map,
        2: AbacusNd2Map,
        3: AbacusNd3Map,
        4: AbacusNd4Map
    }

    public MAX_NODE_CAPACITY = 1000;

    public algorithm: MessagingSystem = this.DEFAULT_ALGORITHM;
    public numMsgCopies = this.DEFAULT_MESSAGE_COPIES;
    public numNodes = this.DEFAULT_NUMBER_OF_NODES;
    public simSpeed = this.DEFAULT_SIMULATION_SPEED;
    public simTime = this.DEFAULT_SIMULATION_TIME;
    public nodeRadius = this.DEFAULT_NODE_RADIUS;
    public msgFreq = this.DEFAULT_MESSAGE_FREQUENCY;
}